webpackJsonp([96216660452428],{

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(16);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(18);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(17);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(160);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(74);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(26);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 224:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),

/***/ 313:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),

/***/ 721:
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(56),
	    getRawTag = __webpack_require__(194),
	    objectToString = __webpack_require__(196);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 725:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(56),
	    arrayMap = __webpack_require__(224),
	    isArray = __webpack_require__(27),
	    isSymbol = __webpack_require__(197);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(313),
	    deburr = __webpack_require__(735),
	    words = __webpack_require__(741);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(725);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(56);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 731:
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),

/***/ 196:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(110);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 734:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(729),
	    toString = __webpack_require__(150);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),

/***/ 32:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(51),
	    isObjectLike = __webpack_require__(32);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(728);
	
	/**
	 * Converts `string` to
	 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the kebab cased string.
	 * @example
	 *
	 * _.kebabCase('Foo Bar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('fooBar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('__FOO_BAR__');
	 * // => 'foo-bar'
	 */
	var kebabCase = createCompounder(function(result, word, index) {
	  return result + (index ? '-' : '') + word.toLowerCase();
	});
	
	module.exports = kebabCase;


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(323);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(721),
	    hasUnicodeWord = __webpack_require__(731),
	    toString = __webpack_require__(150),
	    unicodeWords = __webpack_require__(734);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    padding: 1.3rem;\n    background: ", ";\n    color: ", ";\n"], ["\n    padding: 1.3rem;\n    background: ", ";\n    color: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    @media (min-width: ", "px) {\n        text-align: left;\n    }\n"], ["\n    text-align: center;\n    @media (min-width: ", "px) {\n        text-align: left;\n    }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    width: 100px;\n    height: 100px;\n    border-radius: 100px;\n    background-size: cover;\n    background-position: center;\n    margin: 0 auto 1rem auto;\n    overflow: hidden;\n    @media (min-width: ", "px) {\n        margin: 0;\n    }\n"], ["\n    width: 100px;\n    height: 100px;\n    border-radius: 100px;\n    background-size: cover;\n    background-position: center;\n    margin: 0 auto 1rem auto;\n    overflow: hidden;\n    @media (min-width: ", "px) {\n        margin: 0;\n    }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    font-size: 1.2rem;\n    font-weight: 900;\n    margin-bottom: 1em;\n"], ["\n    font-size: 1.2rem;\n    font-weight: 900;\n    margin-bottom: 1em;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    margin: 0;\n"], ["\n    margin: 0;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    font-size: 14px;\n    text-transform: uppercase;\n    margin: 0;\n    color: ", ";\n"], ["\n    font-size: 14px;\n    text-transform: uppercase;\n    margin: 0;\n    color: ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n    font-size: 14px;\n    margin-bottom: 2em;\n"], ["\n    font-size: 14px;\n    margin-bottom: 2em;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n    color: ", "\n    font-size: 14px;\n    text-decoration: underline;\n    font-weight: normal;\n"], ["\n    color: ", "\n    font-size: 14px;\n    text-decoration: underline;\n    font-weight: normal;\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n    color: ", "\n    font-size: 14px;\n    font-weight: normal;\n    margin-bottom: 1em;\n    display: inline-block;\n    font-size: 12px;\n"], ["\n    color: ", "\n    font-size: 14px;\n    font-weight: normal;\n    margin-bottom: 1em;\n    display: inline-block;\n    font-size: 12px;\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n    display: table;\n    padding-bottom: 2rem;\n"], ["\n    display: table;\n    padding-bottom: 2rem;\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n    display: table-row;\n    font-size: 0.8rem;\n    color: ", ";\n"], ["\n    display: table-row;\n    font-size: 0.8rem;\n    color: ", ";\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n    display: table-cell;\n    padding-right: 1rem;\n    padding-bottom: 1em;\n"], ["\n    display: table-cell;\n    padding-right: 1rem;\n    padding-bottom: 1em;\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n    display: table-cell;\n    padding-bottom: 1em;\n"], ["\n    display: table-cell;\n    padding-bottom: 1em;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _gatsbyImage = __webpack_require__(677);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _theme = __webpack_require__(6);
	
	var _Icon = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _theme.colors.background, _theme.colors.white);
	
	var ProfileColumn = (0, _styledComponents2.default)(_rlaComponents.Column)(_templateObject2, _theme.breakpoints.xlarge);
	
	var ProfileImage = _styledComponents2.default.div(_templateObject3, _theme.breakpoints.xlarge);
	
	var Title = _styledComponents2.default.h3(_templateObject4);
	
	var Name = Title.extend(_templateObject5);
	
	var Role = _styledComponents2.default.p(_templateObject6, _theme.colors.lightGray);
	
	var Bio = _styledComponents2.default.p(_templateObject7);
	
	var MoreLink = _styledComponents2.default.a(_templateObject8, _theme.colors.white);
	
	var Email = _styledComponents2.default.a(_templateObject9, _theme.colors.accent);
	
	var RecentPostList = _styledComponents2.default.div(_templateObject10);
	var PostLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject11, _theme.colors.white);
	var PostDate = _styledComponents2.default.div(_templateObject12);
	var PostTitle = _styledComponents2.default.div(_templateObject13);
	var Author = function Author(_ref) {
	    var author = _ref.author;
	
	    var hasProfileImage = Boolean(author.frontmatter.profile.responsive.childImageSharp);
	
	    return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	            _rlaComponents.Row,
	            { collapse: true },
	            hasProfileImage && _react2.default.createElement(
	                ProfileColumn,
	                { xlarge: 5 },
	                _react2.default.createElement(
	                    ProfileImage,
	                    null,
	                    _react2.default.createElement(_gatsbyImage2.default, {
	                        resolutions: author.frontmatter.profile.responsive.childImageSharp.resolutions
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                ProfileColumn,
	                { collapse: !hasProfileImage, xlarge: 7 },
	                _react2.default.createElement(
	                    Name,
	                    null,
	                    author.frontmatter.title
	                ),
	                _react2.default.createElement(
	                    Role,
	                    null,
	                    author.frontmatter.role
	                ),
	                _react2.default.createElement(
	                    Email,
	                    null,
	                    author.frontmatter.email
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    author.frontmatter.linkedIn && _react2.default.createElement(_Icon.Social, {
	                        size: 30,
	                        icon: "linkedin-in",
	                        href: author.frontmatter.linkedIn
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            Bio,
	            null,
	            author.excerpt
	        ),
	        author.fields.posts && author.fields.posts.length > 0 && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                Title,
	                null,
	                "Recent Posts:"
	            ),
	            _react2.default.createElement(
	                RecentPostList,
	                null,
	                author.fields.posts.map(function (post, index) {
	                    return _react2.default.createElement(
	                        PostLink,
	                        { to: post.fields.slug },
	                        _react2.default.createElement(
	                            PostDate,
	                            null,
	                            post.frontmatter.date
	                        ),
	                        _react2.default.createElement(
	                            PostTitle,
	                            null,
	                            post.frontmatter.title
	                        )
	                    );
	                })
	            ),
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                    to: "/authors/" + _.kebabCase(author.frontmatter.title) },
	                "More posts by ",
	                author.frontmatter.title,
	                " ",
	                _react2.default.createElement(_reactFontawesome2.default, {
	                    icon: "arrow-right",
	                    transform: "shrink-3 down-2"
	                })
	            )
	        )
	    );
	};
	
	exports.default = Author;
	module.exports = exports["default"];

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    @media (min-width: 1516px) {\n        position: absolute;\n    }\n"], ["\n    @media (min-width: 1516px) {\n        position: absolute;\n    }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    font-size: 1.2em;\n    display: inline-block;\n    padding: ", "em 0;\n    color: ", ";\n    cursor: pointer;\n    @media (min-width: 1516px) {\n        padding: 0;\n    }\n"], ["\n    font-size: 1.2em;\n    display: inline-block;\n    padding: ", "em 0;\n    color: ", ";\n    cursor: pointer;\n    @media (min-width: 1516px) {\n        padding: 0;\n    }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledRow = (0, _styledComponents2.default)(_rlaComponents.Row)(_templateObject);
	
	var Button = _styledComponents2.default.a.attrs({
	    role: "button"
	})(_templateObject2, _theme.spacing.padding, _theme.colors.lightGray);
	
	var BackButton = function BackButton(_ref) {
	    var goBack = _ref.goBack;
	    return _react2.default.createElement(
	        StyledRow,
	        { expanded: true },
	        _react2.default.createElement(
	            _rlaComponents.Column,
	            null,
	            _react2.default.createElement(
	                Button,
	                { onClick: goBack },
	                console.log(goBack),
	                _react2.default.createElement(_reactFontawesome2.default, { icon: "arrow-left" })
	            )
	        )
	    );
	};
	
	exports.default = BackButton;
	module.exports = exports["default"];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 40vw;\n    max-height: 450px;\n    min-height: 180px;\n    background-size: cover;\n    background-position: center;\n    background-image: url('", "');\n    margin-bottom: 2.8em;\n    position: relative;\n"], ["\n    width: 100%;\n    height: 40vw;\n    max-height: 450px;\n    min-height: 180px;\n    background-size: cover;\n    background-position: center;\n    background-image: url('", "');\n    margin-bottom: 2.8em;\n    position: relative;\n"]);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Hero = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.src;
	});
	
	exports.default = Hero;
	module.exports = exports["default"];

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    position: relative;\n    padding: 5rem 0 2rem;\n    background-color: ", ";\n    color: ", ";\n    font-size: ", "rem;\n    line-height: 1.3;\n    text-transform: uppercase;\n    display: inline-block;\n"], ["\n    position: relative;\n    padding: 5rem 0 2rem;\n    background-color: ", ";\n    color: ", ";\n    font-size: ", "rem;\n    line-height: 1.3;\n    text-transform: uppercase;\n    display: inline-block;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(6);
	
	var _helpers = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SidebarDateContainer = _styledComponents2.default.blockquote(_templateObject, function (props) {
	    return props.background;
	}, function (props) {
	    return props.color;
	}, function (props) {
	    return props.fontSize;
	});
	
	var SidebarDate = function SidebarDate(_ref) {
	    var date = _ref.date,
	        prefix = _ref.prefix,
	        rest = _objectWithoutProperties(_ref, ["date", "prefix"]);
	
	    console.log(date);
	    return _react2.default.createElement(
	        SidebarDateContainer,
	        rest,
	        prefix,
	        " ",
	        (0, _helpers.dateFormat)(date)
	    );
	};
	
	SidebarDate.propTypes = {
	    date: _propTypes2.default.string.isRequired,
	    background: _propTypes2.default.string,
	    color: _propTypes2.default.string,
	    fontSize: _propTypes2.default.number,
	    prefix: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
	};
	
	SidebarDate.defaultProps = {
	    background: _theme.colors.white,
	    color: _theme.colors.accent,
	    fontSize: 1,
	    prefix: _react2.default.createElement(
	        "span",
	        null,
	        "\u2014"
	    )
	};
	
	exports.default = SidebarDate;
	module.exports = exports["default"];

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    padding: 1.3rem;\n    background: #e4e4e3;\n    color: ", ";\n"], ["\n    padding: 1.3rem;\n    background: #e4e4e3;\n    color: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    font-weight: 900;\n    margin-bottom: 1em;\n"], ["\n    font-weight: 900;\n    margin-bottom: 1em;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    font-size: 14px;\n    font-style: italic;\n    font-weight: normal;\n    color: ", ";\n"], ["\n    font-size: 14px;\n    font-style: italic;\n    font-weight: normal;\n    color: ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _kebabCase = __webpack_require__(738);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _theme.colors.background);
	
	var Title = _styledComponents2.default.h4(_templateObject2);
	
	var Tag = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject3, _theme.colors.background);
	
	var Tags = function Tags(_ref) {
	    var tags = _ref.tags;
	
	    return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	            Title,
	            null,
	            "Tags:"
	        ),
	        tags.map(function (tag, index) {
	            return _react2.default.createElement(
	                "span",
	                { key: index },
	                _react2.default.createElement(
	                    Tag,
	                    { to: "/tags/" + (0, _kebabCase2.default)(tag) },
	                    tag
	                ),
	                index != tags.length - 1 && ", "
	            );
	        })
	    );
	};
	
	exports.default = Tags;
	module.exports = exports["default"];

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = exports.NewsTemplate = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    @media (min-width: ", "px) {\n        max-width: 400px;\n        float: right;\n    }\n"], ["\n    @media (min-width: ", "px) {\n        max-width: 400px;\n        float: right;\n    }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    margin: 0 1rem 3rem 0;\n    color: #07172C;\n    font-weight: 500;\n    p{\n        margin-bottom 0.5em;\n    }\n"], ["\n    margin: 0 1rem 3rem 0;\n    color: #07172C;\n    font-weight: 500;\n    p{\n        margin-bottom 0.5em;\n    }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _image = __webpack_require__(44);
	
	var _theme = __webpack_require__(6);
	
	var _Content = __webpack_require__(35);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _PageDetailContainer = __webpack_require__(46);
	
	var _PageDetailContainer2 = _interopRequireDefault(_PageDetailContainer);
	
	var _PullQuote = __webpack_require__(108);
	
	var _PullQuote2 = _interopRequireDefault(_PullQuote);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _SidebarDate = __webpack_require__(569);
	
	var _SidebarDate2 = _interopRequireDefault(_SidebarDate);
	
	var _Icon = __webpack_require__(73);
	
	var _NewsSummary = __webpack_require__(158);
	
	var _NewsSummary2 = _interopRequireDefault(_NewsSummary);
	
	var _Author = __webpack_require__(568);
	
	var _Author2 = _interopRequireDefault(_Author);
	
	var _BackButton = __webpack_require__(145);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _Hero = __webpack_require__(146);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Tags = __webpack_require__(570);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _helpers = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Sidebar = (0, _styledComponents2.default)(_rlaComponents.Column)(_templateObject, _theme.breakpoints.xlarge);
	
	var SocialContainer = _styledComponents2.default.div(_templateObject2);
	
	var NewsTemplate = exports.NewsTemplate = function NewsTemplate(_ref) {
	    var content = _ref.content,
	        contentComponent = _ref.contentComponent,
	        hero = _ref.hero,
	        intro = _ref.intro,
	        sideHeading = _ref.sideHeading,
	        galleryImages = _ref.galleryImages,
	        author = _ref.author,
	        title = _ref.title,
	        date = _ref.date,
	        helmet = _ref.helmet,
	        previous = _ref.previous,
	        next = _ref.next,
	        transition = _ref.transition,
	        history = _ref.history,
	        tags = _ref.tags;
	
	    var PostContent = contentComponent || _Content.HTMLContent;
	    return _react2.default.createElement(
	        "div",
	        { style: transition && transition.style },
	        _react2.default.createElement(
	            _PageDetailContainer2.default,
	            null,
	            helmet || "",
	            _react2.default.createElement(_BackButton2.default, { goBack: history.goBack }),
	            hero && _react2.default.createElement(
	                _rlaComponents.Row,
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    null,
	                    _react2.default.createElement(_Hero2.default, { src: (0, _image.getOriginalImageSrc)(hero) }),
	                    " "
	                )
	            ),
	            _react2.default.createElement(
	                _rlaComponents.Row,
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { medium: 8 },
	                    _react2.default.createElement(
	                        _HeaderBlock2.default,
	                        {
	                            textAlign: "left",
	                            baseColor: _theme.colors.background,
	                            fontSize: 3,
	                            padding: {
	                                top: 0.6,
	                                right: 0,
	                                bottom: 2.4,
	                                left: 0
	                            } },
	                        title
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _rlaComponents.Row,
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { medium: 7, className: "postContent" },
	                    _react2.default.createElement(PostContent, {
	                        content: content,
	                        className: "cms-content"
	                    })
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { medium: 1 },
	                    "\xA0"
	                ),
	                _react2.default.createElement(
	                    Sidebar,
	                    { medium: 4 },
	                    _react2.default.createElement(_SidebarDate2.default, { date: date.toLowerCase() }),
	                    _react2.default.createElement(
	                        _PullQuote2.default,
	                        { fontSize: 1.8, padding: "0 0 2.6rem" },
	                        sideHeading
	                    ),
	                    _react2.default.createElement(
	                        SocialContainer,
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Share This Post"
	                        ),
	                        (0, _helpers.isBrowser)() && _react2.default.createElement(_Icon.Social, {
	                            size: 50,
	                            icon: "linkedin-in",
	                            href: "https://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href + "&title=" + title + "&summary=" + sideHeading,
	                            color: _theme.colors.background,
	                            borderColor: _theme.colors.background,
	                            transform: "shrink-10 up-0.5",
	                            margin: "0 1rem 0 0"
	                        }),
	                        (0, _helpers.isBrowser)() && _react2.default.createElement(_Icon.Social, {
	                            size: 50,
	                            icon: "twitter",
	                            href: "https://twitter.com/home?status=" + title + " - " + sideHeading + " - " + window.location.href,
	                            color: _theme.colors.background,
	                            borderColor: _theme.colors.background,
	                            transform: "shrink-10 ",
	                            margin: "0 1rem 0 0 "
	                        })
	                    ),
	                    author && _react2.default.createElement(_Author2.default, { author: author }),
	                    tags && _react2.default.createElement(_Tags2.default, { tags: tags })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _rlaComponents.Row,
	            { collapse: true, expanded: true },
	            _react2.default.createElement(
	                _rlaComponents.Column,
	                { medium: 6, collapse: true },
	                previous ? _react2.default.createElement(_NewsSummary2.default, { story: previous, minHeight: 30 }) : _react2.default.createElement(
	                    "span",
	                    null,
	                    "\xA0"
	                )
	            ),
	            _react2.default.createElement(
	                _rlaComponents.Column,
	                { medium: 6, collapse: true },
	                next ? _react2.default.createElement(_NewsSummary2.default, { story: next, minHeight: 30 }) : _react2.default.createElement(
	                    "span",
	                    null,
	                    "\xA0"
	                )
	            )
	        )
	    );
	};
	
	exports.default = function (_ref2) {
	    var history = _ref2.history,
	        data = _ref2.data,
	        pathContext = _ref2.pathContext,
	        transition = _ref2.transition;
	
	    //console.log(data, transition);
	    var news = data.markdownRemark;
	    var previous = pathContext.previous,
	        next = pathContext.next,
	        slug = pathContext.slug;
	    var _news$frontmatter = news.frontmatter,
	        title = _news$frontmatter.title,
	        metaTitle = _news$frontmatter.metaTitle,
	        metaDescription = _news$frontmatter.metaDescription,
	        hero = _news$frontmatter.hero;
	
	    var pageTitle = metaTitle || title + " | News | RLA Group | Full Service Advertising Agency";
	    return _react2.default.createElement(NewsTemplate, {
	        description: news.frontmatter.description,
	        helmet: _react2.default.createElement(
	            _reactHelmet2.default,
	            { title: pageTitle },
	            _react2.default.createElement("meta", { name: "title", content: pageTitle }),
	            title && _react2.default.createElement("meta", { property: "og:title", content: title }),
	            hero && _react2.default.createElement("meta", {
	                property: "og:image",
	                content: "//www.rla.co.uk" + hero.original
	            }),
	            metaDescription && _react2.default.createElement("meta", {
	                property: "og:description",
	                content: metaDescription
	            }),
	            _react2.default.createElement("meta", {
	                property: "og:url",
	                content: "//www.rla.co.uk" + slug
	            }),
	            metaDescription && _react2.default.createElement("meta", { name: "description", content: metaDescription })
	        ),
	        title: news.frontmatter.title,
	        date: news.frontmatter.date,
	        hero: news.frontmatter.hero,
	        intro: news.frontmatter.intro,
	        sideHeading: news.frontmatter.sideHeading,
	        content: news.html,
	        galleryImages: news.frontmatter.galleryImages,
	        previous: previous,
	        next: next,
	        transition: transition,
	        history: history,
	        author: news.frontmatter.author,
	        tags: news.frontmatter.tags
	    });
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-news-js-0bf93f68fe60bab82bfa.js